import React from 'react';

import LogoWeb from '../../../LogoWeb';
import SocialLinks from '../../SocialLinks';

import './MyInfo.scss';

export default function MyInfo() {
	return (
		<div className="my-info">
			<LogoWeb />
			<h4>
				Entra en el mundo del desarrollo web, disfruta creando proyectos
				de todo tipo, deja que tu imaginacion fluya y crea verdaderas
				maravillas!!!
			</h4>
			<SocialLinks />
		</div>
	);
}
